import {HStack, VStack} from 'platform/foundation';

import {SourcingVehicleListItemResponseBody} from '@dms/api/core';

import {suffixTestId, TestIdProps} from 'shared/web';

import {ActionButtonsVehicle} from '../../ActionButtonsVehicle/ActionButtonsVehicle';
import {convertVehicleTagsToVehicleHighlights} from '../../VehicleHighlights/utils/convertVehicleTagsToVehicleHighlights';
import {VehicleHighlights} from '../../VehicleHighlights/VehicleHighlights';
import {VehiclePriceForm} from '../../VehiclePriceForm/VehiclePriceForm';

interface TableDetailRowProps extends TestIdProps {
  row: {index: number; original: SourcingVehicleListItemResponseBody};
  setLastVisitedVehicle?: (adId: string, index: number) => void;
}

export function TableDetailRow({
  row: {
    index,
    original,
    original: {vehicleSummary, features},
  },
  setLastVisitedVehicle,
  ...props
}: TableDetailRowProps) {
  const vehicleData = original.sourcingVehicle;
  const isDisabled = original.sourcingVehicle.isAvailable === false;

  return (
    <VStack spacing={3}>
      <HStack justify="space-between">
        <VehicleHighlights
          data={convertVehicleTagsToVehicleHighlights(
            [],
            [],
            Object.values(features).filter((i) => i.isHighlight)
          )}
        />
        <ActionButtonsVehicle
          vehicle={original}
          isDisabled={isDisabled}
          onDetailOpen={() => setLastVisitedVehicle?.(vehicleData?.adId, index)}
          data-testid={suffixTestId('actionButtonsVehicle', props)}
        />
      </HStack>
      <VehiclePriceForm
        isDisabled={isDisabled}
        vehicleId={vehicleData?.adId}
        initialValues={{
          comment: vehicleSummary?.comment as string,
          purchasePrice: `${vehicleSummary?.purchasePrice}`,
          sellingPrice: `${vehicleSummary?.sellingPrice}`,
        }}
        data-testid={suffixTestId('vehiclePriceForm', props)}
      />
    </VStack>
  );
}
